import { useCallback, useContext } from 'react'

import { WidgetAppTemplate } from 'modules/app-registry/templates/WidgetAppTemplate'
import { UserContext } from 'shared/contexts/User'
import { useNotificationStore } from 'shared/stores/notificationStore'

const NotificationApp = () => {
  const { user } = useContext(UserContext)
  const {
    setNotificationPaneState,
    notificationPaneState,
    notificationState,
    setNotificationState
  } = useNotificationStore()

  const setNotificationPaneStateForWidget = useCallback(
    (state: 'opened' | 'closed') => setNotificationPaneState(state),
    [setNotificationPaneState]
  )

  return (
    <WidgetAppTemplate
      user={user}
      appName='Notifications'
      scope='notification'
      envKey='notificationApp'
      entryPath='./NotificationApp'
      url={process.env.REACT_APP_NOTIFICATION_APP_DEV_PATH}
      appProps={{
        user,
        setNotificationPaneState: setNotificationPaneStateForWidget,
        notificationPaneState,
        setNotificationState,
        notificationState,
        panePosition: 'left'
      }}
    />
  )
}

export { NotificationApp }
